import React from "react";
import ModalCardComponent from "./modal-card.component";
import {CloseIcon, TrashIcon} from "../utils/image";
import {useDispatch, useSelector} from "react-redux";
import {setToolsModalVisibility} from "../reducers/tools.reducer";

const DeleteConfirmationComponent = ({onDelete}) => {
    const dispatch = useDispatch()
    const {modalVisibility, alertMessage} = useSelector(state => state.toolsReducer)

    const closeModalHandler = () => {
        dispatch(setToolsModalVisibility({delete: false}))
    }

    return (
        <ModalCardComponent
            visibility={modalVisibility.delete}
            onClose={closeModalHandler}
            content={
                <div className={"relative"}>
                    <div className={"col justify-center p-10 space-y-7 bg-white rounded-xl"}>
                        <p className={"text-eerie-black text-center text-base font-semibold"}>Delete Item</p>
                        <img src={TrashIcon} alt="TrashIcon" className={"w-14 mx-auto"}/>
                        <p className={"text-monstera text-center text-base"}>{!!alertMessage ? alertMessage : 'Apakah yakin ingin menghapus item ini ?'}</p>
                        <div className={"row justify-center font-semibold items-center space-x-10"}>
                            <div
                                className={"row justify-center px-8 py-2 border border-placebo text-forged-steel rounded-lg hover:text-white hover:bg-dazzle cursor-pointer"}
                                onClick={closeModalHandler}>
                                <p>Batal</p>
                            </div>
                            <button type={"submit"} onClick={onDelete}
                                    className={"row justify-center px-8 py-2 bg-battleship-green hover:bg-monstera text-white rounded-lg cursor-pointer"}>
                                <p>Hapus</p>
                            </button>
                        </div>
                    </div>
                    <img src={CloseIcon} alt="closeButton"
                         className={`w-5 absolute right-4 top-2 cursor-pointer`}
                         onClick={closeModalHandler}/>
                </div>
            }
        />
    )
}

export default DeleteConfirmationComponent
